<template>
    <div>
        <card-header title="Enrollments" icon="fa-users"></card-header>

        <card-body>
            <card-list>
                <subheader-list-item title="Enrollments" icon="fa-users" :badge="enrollments.length + ' Results'" />
                <enrollment-tile
                    :card="card"
                    :enrollment="enroll"
                    :course="course"
                    v-for="enroll in enrollments"
                    @click="$openCard('enrollment', {enrollId: enroll.id, courseId: props.courseId}, card)"
                    :active="(child && child.definition.component === 'enrollment' && enroll.id === parseInt(child.props.enrollId))"
                />
            </card-list>
        </card-body>

        <card-footer v-if="enrollments.length === 100">
            <i class="fas fa-exclamation-triangle mr-2 has-text-warning"></i><strong>There may be more results. </strong>Refine your search criteria.
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import CardList from "@/TIER/components/CardList";
    import CardSubheader from "@/TIER/components/CardSubheader";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import CardFooter from "@/TIER/components/CardFooter";


    import {client as http} from "@/http_client";
    import ConferenceTile from "../../../components/tiles/ConferenceTile";
    import RegistrationTile from "../../../components/tiles/RegistrationTile";
    import CardToolbar from "../../../TIER/components/CardToolbar.vue";
    import EnrollmentTile from "../../../components/tiles/EnrollmentTile.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {EnrollmentTile, CardToolbar, RegistrationTile, ConferenceTile, CardFooter, CardHeader, CardBody, SearchListItem, CardList, CardSubheader, SubheaderListItem},
        data() {
            return {
                course: null,
                enrollments: []
            };
        },
        methods: {
            load: function () {
                http.get('courses/new/' + this.props.courseId).then(response => {
                    this.course = response.data;
                });
            },
            searchRegistrations: function () {
                /**
                 *         where: {
            course_id: 80,
            users: {
                OR: [
                    {
                        user_certification: {
                            some: {
                                certification_number: {
                                    contains: '123'
                                }
                            }
                        }
                    }
                ]
            }
        },
                 */
                this.$emit('loading', true);
                http.post('enrollments/search', {
                    where: {
                        course_id: this.props.courseId,
                        is_deleted: 0,
                        users: {
                            OR: this.props.query.split(' ').map(q => {
                                return {
                                    OR: [
                                        {first_name: {contains: q,},},
                                        {last_name: {contains: q,},},
                                        {
                                            user_certification: {
                                                some: {
                                                    certification_number: {
                                                        contains: q,
                                                    }
                                                }
                                            }
                                        }
                                    ],
                                };
                            }),
                        }
                    }
                }).then(response => {
                    this.enrollments = response.data;
                    this.count = response.data.length;
                    this.$emit('loading', false);
                });
            }
        },
        watch: {
            'props.query': function () {
                this.searchRegistrations();
            }
        },
        mounted: function () {
            this.load();
            this.searchRegistrations();
        }
    };
</script>
